module.exports = __webpack_public_path__ + "img/404.87a8353f.png";